module.exports = __webpack_public_path__ + "img/debtPayingAbility5.9f7d66a1.png";